
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Autoplay } from "swiper";

const TwoBanner = ({ data, index }) => (
  <>
    <div className="flex-1 flex mx-1">
      <img
        className="object-cover flex h-full w-full rounded-xl"
        src={data.url}
        alt=""
      />
    </div>
  </>
);

export default function MidBanner({ data = [] }) {
  return data.length ? (
    <>
      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        slidesPerView={2}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
      >
        {data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="w-full sm:h-[260px] h-[80px] flex">
                {/* {(index + 1)%2 == 0 } */}
              <TwoBanner data={item} index={index} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  ) : (
    <></>
  );
}
